var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('Hero'),_c('Services'),_c('Stats'),_c('Cases'),_c('BrandCases'),_c('News'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }